import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitControlSelectListModel } from '@apps-common/types/portal/unit-control'

export const QUERY_KEY_MY_MONITORING_GET_CONTROL_SELECT_LIST_WITH_STATE = (unitId?: string) =>
  ['getMyMonitoringControlSelectListWithState', unitId].filter(Boolean)

const getMyMonitoringControlSelectListWithState = async (unitId?: string): Promise<IUnitControlSelectListModel[]> =>
  axios.get(`/my-monitoring/control/GetControlsSelectList?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getMyMonitoringControlSelectListWithState

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId?: string
}

export const useMyMonitoringGetControlSelectListWithState = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_CONTROL_SELECT_LIST_WITH_STATE(unitId),
    queryFn: () => getMyMonitoringControlSelectListWithState(unitId)
  })
